import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HelixBookRepositoryService } from '../../services/helix-book-repository.service';
import { SearchPanelModel } from '../../interfaces/helix-book.interfaces';
import { Observable, map } from 'rxjs';

@Component({
  selector: 'app-helix-book-search-panel',
  templateUrl: './search-panel.component.html',
  styleUrls: ['./search-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchPanelComponent {
  constructor(public repository: HelixBookRepositoryService) {}

  keyboards$: Observable<SearchPanelModel[]> = this.repository
    .getItemsList()
    .pipe(map((items) => this.repository.getKeyboards(items)));

  selectKey(key: string): void {
    this.repository.setActiveKey(key);
    this.repository.setScrollEvent(true);
  }
}
